import BarChartSectionAverages from './BarChartSectionAverages';

const MultiChartSectionAveragesDashboard = ({ data }) => {
  const transformedData = {
    numericPercentage: data?.numericPercentage,
    sections: (data?.sections ?? []).map((item) => {
      const sectionNumber = item.name.split('-').pop().trim();
      return {
        ...item,
        sectionLabel: `Section ${sectionNumber}`,
      };
    }),
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        alignItems: 'center',
      }}
    >
      <BarChartSectionAverages data={transformedData} />
    </div>
  );
};

export default MultiChartSectionAveragesDashboard;
